import tapp from '@homeservices/tapp';
import MIXPANEL from '@homeservices/tapp/trackers/mixpanel';
import { PROPERTY_BLACKLIST } from '@/constants/property-blacklist';

export const setupTracking = ({ events }) => {
  function waitForMixpanel () {
    if (typeof window.$mixpanelKey !== 'undefined') {
      MIXPANEL.init(window.$mixpanelKey, { property_blacklist: PROPERTY_BLACKLIST });
    } else {
      setTimeout(waitForMixpanel, 250);
    }
  }

  waitForMixpanel();

  tapp.init({
    // Give the framework a function to call to subscribe to each event
    listen: events.$on.bind(events),
    events: {
      [events.AUTH_REDIRECT_ERROR]: MIXPANEL,
      [events.HOMEPAGE_MODAL]: MIXPANEL,
      [events.HOMEPAGE_SEARCH]: MIXPANEL,
      [events.REQUEST_ENTER_FLOW]: MIXPANEL,
      [events.REQUEST_JOBSUBMIT_SUCCESS]: MIXPANEL,
      [events.REQUEST_JOBSUBMIT_ERROR]: MIXPANEL,
      [events.REQUEST_JOBSUBMIT_SCAM]: MIXPANEL,
      [events.REQUEST_VALIDATION_ERROR]: MIXPANEL,
      [events.REQUEST_NO_PROS_AVAILABLE]: MIXPANEL,
      [events.REQUEST_HD_REDIRECT]: MIXPANEL,
      [events.REQUEST_HD_REDIRECT_COMPLETE]: MIXPANEL,
      [events.PAGE_LOAD]: MIXPANEL,
      [events.CONSUMER_REQUEST_SERVICE]: MIXPANEL,
      [events.CONSUMER_HIRED_FEEDBACK]: MIXPANEL,
      [events.CONSUMER_NOT_HIRED_FEEDBACK]: MIXPANEL,
      [events.CONSUMER_VIEWED_PRO_CARD]: MIXPANEL,
      [events.CONSUMER_CANCEL_REQUEST]: MIXPANEL,
      [events.USER_LOGIN]: (eventName, { email }) => {
        if (window.usabilla_live) {
          window.usabilla_live('data', { email });
        }
      },
      [events.USER_IDENTIFY]: (eventName, payload = {}) => {
        MIXPANEL.identify(payload.id);
        MIXPANEL.peopleSetOnce({ TotalPasses: 0 });
      },
      [events.USER_CREATION]: (eventName, payload) => {
        MIXPANEL.alias(payload.id);
      },
      [events.INCREMENT]: MIXPANEL.peopleIncrement,
      [events.MODAL_CLICK]: MIXPANEL,
      [events.CAROUSEL_CLICK]: MIXPANEL,
      [events.REVIEWS_CLICK]: MIXPANEL,
      [events.REVIEWS_RETRY]: MIXPANEL,
      [events.REVIEWS_ERROR]: MIXPANEL,
      [events.LEAD_SUBMIT]: MIXPANEL,
      [events.LEAD_FAILURE]: MIXPANEL,
      [events.LEAD_SUCCESS]: MIXPANEL,
      [events.FAQ_VIEWED]: MIXPANEL,
      [events.FAQ_PHONE_LINK_CLICKED]: MIXPANEL,
      [events.FAQ_EMAIL_LINK_CLICKED]: MIXPANEL,
      [events.URL_CLICK]: MIXPANEL,
      [events.TESTIMONIAL_CONTENT_ERROR]: MIXPANEL,
      [events.TESTIMONIAL_ERROR]: MIXPANEL,
      [events.LOGIN_TAB_SWITCH]: MIXPANEL,
      [events.OTC_REQUEST_CLICK]: MIXPANEL,
      [events.OTC_ENTER_CLICK]: MIXPANEL,
      [events.OTC_SEND_ANOTHER_CODE_CLICK]: MIXPANEL,
      [events.OTC_ENTER_CLICK_ERROR]: MIXPANEL,
      [events.OTC_REQUEST_CLICK_ERROR]: MIXPANEL,
      [events.SAVE_PASSWORD_CLICK]: MIXPANEL,
      [events.DO_NOT_WANT_TO_CREATE_PASSWORD_CLICK]: MIXPANEL,
      [events.OTC_LOGIN_PAGE_CLICK]: MIXPANEL,
      [events.TRENDING_SERVICES_ZIP_SEARCH]: MIXPANEL,
      [events.TRENDING_SERVICES_CLICK]: MIXPANEL,
      [events.INVITE_URL_CLICKED]: MIXPANEL,
      [events.INVITE_SHARE_CLICKED]: MIXPANEL,
      [events.NOTIFICATIONS_TAB_CHANGE]: MIXPANEL,
      [events.WHATS_NEW_SEARCH]: MIXPANEL,
      [events.WHATS_NEW_BUTTON_CLICK]: MIXPANEL,
      [events.SUB_STATUS_UPDATE]: MIXPANEL,
      [events.SUB_STATUS_INITIAL]: MIXPANEL,
      [events.SUB_STATUS_FILTER]: MIXPANEL,
      [events.TOOL_RENTAL_CLICK]: MIXPANEL,
      [events.RESOURCE_OPEN_PDF]: MIXPANEL,
      [events.OTHER_CONTACT_STATUS]: MIXPANEL,
      [events.B2B_URL_CLICK]: MIXPANEL,
      [events.USER_LOGIN_FAILURE]: MIXPANEL,
      [events.THUMB_CLICK]: MIXPANEL,
      [events.SURVEY_CLICK]: MIXPANEL,
      [events.VIDEO_RATING]: MIXPANEL,
      [events.OPEN_QUIZ]: MIXPANEL,
      [events.REWATCH_FROM_VIDEO]: MIXPANEL,
      [events.WHAT_IS_THIS_CLICK]: MIXPANEL,
      [events.REWATCH_FROM_QUIZ]: MIXPANEL,
      [events.RETURN_EDUCATION_HOME]: MIXPANEL,
      [events.WATCH_VIDEO]: MIXPANEL,
      [events.VIDEO_SEARCH]: MIXPANEL,
      [events.VIDEO_CATEGORY_CLICK]: MIXPANEL,
      [events.VIDEO_MY_PROGRESS_CLICK]: MIXPANEL,
      [events.QUIZ_MODAL_BUTTON]: MIXPANEL,
      [events.QUIZ_SUBMIT]: MIXPANEL,
      [events.QUIZ_FAILED]: MIXPANEL,
      [events.WATCH_NEXT_VIDEO]: MIXPANEL,
      [events.OCCUPATION_EDIT]: MIXPANEL,
      [events.ERROR_PAGE_LOAD]: MIXPANEL,
      [events.POSSIBLE_AD_BLOCKER]: MIXPANEL,
      [events.LIMIT_MODAL_OPEN]: MIXPANEL,
    },
  });
};
